import axios from "axios";
import store from "@/store";
import router from "@/router";
import { URL } from "@/constants";

let ax = axios.create({ baseURL: URL });

ax.interceptors.request.use(config => {
    const token = localStorage.getItem("token");
    if (token != null)
        config.headers['x-access-token'] = token;

    return config;
});

ax.interceptors.response.use(
    function(response) {
        return response;
    },
    function(error) {
        if (error.response && error.response.status === 401) {
            store.dispatch("security/removeToken");
            router.push({ name: "login" });
        } else if (error.response && error.response.status === 403) {
            store.dispatch("security/removeToken");
            router.push({ name: "login" });
        } else if (error.response && error.response.status === 500) {
            console.log("500");
        }
        return Promise.reject(error);
    }
);

export { ax };
